import { Select } from 'antd';
import React from 'react';
import type { Student } from './types/student';

type StudentMultiSelectProps = {
  students: Student[];
  value: string[];
  onChange: (studentIds: string[]) => void;
  disabled?: boolean;
  placeholder?: string;
  allowClear?: boolean;
  maxTagCount?: number | 'responsive';
  maxTagPlaceholder?: React.ReactNode;
};

export default function StudentMultiSelect({
  students,
  value,
  onChange,
  disabled,
  placeholder = 'Select students',
  allowClear = false,
  maxTagCount = 'responsive',
  maxTagPlaceholder,
}: StudentMultiSelectProps) {
  const options = students.map((s) => ({
    label: s.name,
    value: s.id,
  }));

  return (
    <Select
      mode="multiple"
      placeholder={placeholder}
      value={value}
      onChange={(v) => onChange(v ?? [])}
      options={options}
      disabled={disabled}
      allowClear={allowClear}
      style={{ width: '100%' }}
      maxTagCount={maxTagCount}
      maxTagPlaceholder={maxTagPlaceholder}
      getPopupContainer={() => document.body}
      dropdownStyle={{ zIndex: 100000000 }}
    />
  );
}
